import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

// TS port of the source (Falah) app's pages/reports/revenue/QuotationRegisterReport.jsx.
const COLUMNS: ReportColumn[] = [
  { key: 'quotation_number', label: 'Quotation #' },
  { key: 'customer_name', label: 'Customer' },
  { key: 'service', label: 'Service' },
  { key: 'quotation_date', label: 'Date' },
  { key: 'amount', label: 'Amount', align: 'right', type: 'money' },
  { key: 'valid_until', label: 'Valid Until' },
  { key: 'status', label: 'Status' },
  { key: 'prepared_by', label: 'Prepared By' },
];

export function QuotationRegisterReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Quotation Register"
      description="All customer quotations with amount, status and validity."
      endpoint="/reports/revenue/quotation-register"
      columns={COLUMNS}
      filters={['status', 'dateRange']}
      statusOptions={listOptions(lists, 'quotation_status')}
    />
  );
}
